import React from "react";
import { Navigate } from "react-router-dom";

import { useAuth } from "./context/AuthContext";
import { routes } from "./Router";

interface ProtectedRouteProps {
  children: React.ReactElement;
}

export default function ProtectedRoute({
  children,
}: ProtectedRouteProps): React.JSX.Element {
  const { isAuthenticated } = useAuth();
  return isAuthenticated ? (
    children
  ) : (
    <Navigate to={routes.login} replace={true} />
  );
}
